import {
  CHANGE_ACTIVE_ITEM_TS_EXPERT,
  CHANGE_ACTIVE_ITEM_CONFIG,
  SOLVE_PROBLEM,
  // ----------------------- Protocol ----------------------------
  CHANGE_ACTIVE_ITEM_PROTOCOL_RESUME,
  CHANGE_ACTIVE_ITEM_PROTOCOL_LIVELIST,
  CHANGE_ACTIVE_ITEM_PROTOCOL_LIVELIST_MATRIX,
  CHANGE_ACTIVE_ITEM_PROTOCOL_GRAPHIC_TOPOLOGY,
  CHANGE_ACTIVE_ITEM_PROTOCOL_LOG,
  // ----------------------- Optic Fiber ----------------------------
  CHANGE_ACTIVE_ITEM_OPTIC_FIBER,
  CHANGE_ACTIVE_ITEM_OPTIC_FIBER_LOG,
  // ----------------------- Physical Medium DP ----------------------------
  CHANGE_ACTIVE_ITEM_DP_LIVELIST,
  CHANGE_ACTIVE_ITEM_DP_LIVELIST_MATRIX,
  CHANGE_ACTIVE_ITEM_DP_OSCILLOSCOPE,
  CHANGE_ACTIVE_ITEM_DP_BAR_GRAPH,
  CHANGE_ACTIVE_ITEM_DP_LOG,
  // ----------------------- Config Route ----------------------------
  CHANGE_ROUTE
} from "actions/types";

export function activeMenuItemReducer(initialState = { activeItem: "/" }, action) {
  switch (action.type) {
    case CHANGE_ACTIVE_ITEM_TS_EXPERT:
      return action.payload.activeItem;
    case CHANGE_ACTIVE_ITEM_CONFIG:
      return action.payload.activeItem;
    // ----------------------- Protocol ----------------------------
    case CHANGE_ACTIVE_ITEM_PROTOCOL_RESUME:
      return action.payload.activeItem;
    case CHANGE_ACTIVE_ITEM_PROTOCOL_LIVELIST:
      return action.payload.activeItem;
    case CHANGE_ACTIVE_ITEM_PROTOCOL_LIVELIST_MATRIX:
      return action.payload.activeItem;
    case CHANGE_ACTIVE_ITEM_PROTOCOL_GRAPHIC_TOPOLOGY:
      return action.payload.activeItem;
    case CHANGE_ACTIVE_ITEM_PROTOCOL_LOG:
      return action.payload.activeItem;
    // ----------------------- Optic Fiber ----------------------------
    case CHANGE_ACTIVE_ITEM_OPTIC_FIBER:
      return action.payload.activeItem;
    case CHANGE_ACTIVE_ITEM_OPTIC_FIBER_LOG:
      return action.payload.activeItem;
    // ----------------------- Physical Medium DP ----------------------------
    case CHANGE_ACTIVE_ITEM_DP_LIVELIST:
      return action.payload.activeItem;
    case CHANGE_ACTIVE_ITEM_DP_LIVELIST_MATRIX:
      return action.payload.activeItem;
    case CHANGE_ACTIVE_ITEM_DP_OSCILLOSCOPE:
      return action.payload.activeItem;
    case CHANGE_ACTIVE_ITEM_DP_BAR_GRAPH:
      return action.payload.activeItem;
    case CHANGE_ACTIVE_ITEM_DP_LOG:
      return action.payload.activeItem;
    // ----------------------- Default ----------------------------
    default:
      return initialState;
  }
}

// ----------------------- Solve Problem ----------------------------
export function solveProblemReducer(initialState = { solve: false, problem: {} }, action) {
  switch (action.type) {
    case SOLVE_PROBLEM:
      return action.payload;
    default:
      return initialState;
  }
}

// ----------------------- Config Route ----------------------------
export function configRouteReducer(initialState = {
  currGenConfigComponent: "general",
  currProtConfigComponent: "protocol",
  currAnDPConfigComponent: "analyzer-dp"
}, action) {
  switch (action.type) {
    case CHANGE_ROUTE:
      return action.payload;
    default:
      return initialState;
  }
}